import React from 'react';
import PropTypes from 'prop-types';

import SelectItem from '../../../../../../../components/form/selectitem';
import CheckboxGroupItem from '../../../../../../../components/form/checkboxgroupitem';
import ModalFooter from '../../../../../../../components/modalfooter';

class MessageTrainingForm extends React.PureComponent {
    render() {
        const { intents, intent_value, onChangeIntent, selected_suggestions, suggestions, onChangeCheckboxGroup, loading, handleCancelClick, handleOkClick } = this.props;
        return (
            <div className="ori-relative ori-full-parent-height ori-b-pad-65">
                <div className="ori-full-parent-height ori-overflow-y-auto ori-overflow-x-hidden ori-lr-pad-15">
                    <SelectItem title="Intents" placeholder="Select Intent" options={intents} value_key="name" name_key="name" value={intent_value} onChange={onChangeIntent} allow_clear show_search is_option_object_type />
                    <CheckboxGroupItem title="Suggestions" checked_items={selected_suggestions} options={suggestions} onChange={onChangeCheckboxGroup} show_search/>
                </div>
                <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <ModalFooter button_ok_text={loading ? "training" : "train"} loading={loading} handleOkClick={handleOkClick} handleCancelClick={handleCancelClick} capsule_button />
                </div>
            </div>
        );
    }
}

MessageTrainingForm.propTypes = {
    intents: PropTypes.array,
    intent_value: PropTypes.string,
    onChangeIntent: PropTypes.func,
    selected_suggestions: PropTypes.array,
    suggestions: PropTypes.array,
    onChangeCheckboxGroup: PropTypes.func,
    loading: PropTypes.bool,
    handleCancelClick: PropTypes.func,
    handleOkClick: PropTypes.func,
};

MessageTrainingForm.defaultProps = {
    loading: false,
    intents: [],
    selected_suggestions: []
};

export default MessageTrainingForm;


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/chatloganalytics/components/messagetrainingform/index.js